import { COLOR_WHITE, COLOR_EGG_SHELL, COLOR_BLACK_NIGHT } from '../colors';

const magenta = {
    BACKGROUND_PATH: './images/TalkingPointsShareable/bg-magenta.jpg',
    TEXT_COLOR: COLOR_WHITE,
    LR_LOGO_PATH: './images/lr-logo-disclaimer-white.svg',
    EQUAL_HOUSING_LOGO_PATH: './images/equal-housing-logo-white.svg',
};

const yellow = {
    BACKGROUND_PATH: './images/TalkingPointsShareable/bg-yellow.jpg',
    TEXT_COLOR: COLOR_EGG_SHELL,
    LR_LOGO_PATH: './images/lr-logo-disclaimer-white.svg',
    EQUAL_HOUSING_LOGO_PATH: './images/equal-housing-logo-white.svg',
};

const black = {
    BACKGROUND_PATH: './images/TalkingPointsShareable/bg-black.jpg',
    TEXT_COLOR: COLOR_WHITE,
    LR_LOGO_PATH: './images/lr-logo-disclaimer-white.svg',
    EQUAL_HOUSING_LOGO_PATH: './images/equal-housing-logo-white.svg',
};

const white = {
    BACKGROUND_PATH: './images/TalkingPointsShareable/bg-white.jpg',
    TEXT_COLOR: COLOR_BLACK_NIGHT,
    LR_LOGO_PATH: './images/lr-logo-disclaimer-white.svg',
    EQUAL_HOUSING_LOGO_PATH: './images/equal-housing-logo-white.svg',
};

export const skins = {
    magenta,
    yellow,
    black,
    white,
};
